/**
 * Created by Pali on 23/06/21.
 */

angular.module("screensApp")

  .controller("VlcController", function ($scope, $rootScope) {
    // Hide Vlc info
    $rootScope.hideVlc = function () {
      $rootScope.settings.vlc.show = false;
      $rootScope.config.DebugJsConsoleLogEnabled && console.log('# INFO: hideVlc()');
      $rootScope.$$phase || $rootScope.$apply();
    };

    // Show vlc info
    ($rootScope.showVlc = function (data) {
      $rootScope.config.DebugJsConsoleLogEnabled && console.log('# INFO: showVlc() data: ' + JSON.stringify(data));
      if (data.qrCode || data.qrCode !== "") {
        $scope.qrCodeString = data.qrCode;
      } else {
        $scope.qrCodeString = $rootScope.config.VLCURL;
      }
      if (data.sbName || data.sbName !== "") {
        $scope.sbName = data.sbName;
      } else {
        $scope.sbName = "Sportbox";
      }
      $rootScope.settings.vlc.show = true;

      $rootScope.$$phase || $rootScope.$apply();
    }),
      function (err) {
        $rootScope.config.DebugJsConsoleLogEnabled && console.log('# ERROR: showVlc() err: ' + err);
        $rootScope.hideVlc();
      };
  });
